var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pager',{attrs:{"skip":_vm.skip,"take":_vm.take,"total":_vm.total,"button-count":_vm.buttonCount,"info":_vm.info,"type":_vm.type,"page-sizes":_vm.pageSizes,"previous-next":_vm.previousNext},on:{"pagechange":_vm.handlePageChange,"pagesizechange":_vm.handlePageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }